import AppForm from "components/AppForm/AppForm";
import CrudPage from "components/CrudPage/CrudPage";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import withRouter from "hoc/withRouter";
import { useLoadAll } from "hooks/useLoadAll";
import { useGetBranches } from "hooks/useGetBranches";
import inputTypeEnum from "enums/inputTypes";
import { snack } from "components/Snack/Snack";
import trainsService from "services/admin/trainsService";

interface TrainFormProps {
  router: any;
  data: any;
}

const TrainForm = ({ router, data }: TrainFormProps) => {
  const {
    navigate,
    params: { id },
  } = router;
  const { train } = data;

  const { data: branchesResponse } = useGetBranches({
    orgID: localStorage.getItem("orgID") || "",
  });
  const branches = (branchesResponse as any)?.data || [];

  const fieldsWithData = [
    {
      key: "number",
      label: "Номер поезда",
      required: true,
      inputType: inputTypeEnum.text,
    },
    {
      key: "route",
      label: "Маршрут",
      inputType: inputTypeEnum.text,
    },
    {
      key: "branchID",
      label: "Филиал",
      inputType: inputTypeEnum.select,
      options: branches.map((b: any) => ({ id: b.id, name: b.name })),
    },
  ];

  const onSubmit = async (formValues: any) => {
    try {
      if (train) {
        await trainsService.put(id, formValues);
        snack("Поезд обновлен успешно!");
      } else {
        await trainsService.post(formValues);
        snack("Поезд создан успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (ex) {
      console.error(ex);
    }
  };

  return (
    <CrudPage title={train ? "Редактирование поезда" : "Создание поезда"}>
      <AppForm onSubmit={onSubmit} data={train} fields={fieldsWithData}></AppForm>
    </CrudPage>
  );
};
export default withRouter(
  withRemoteDataAndSpinner(TrainForm, (router: any) => {
    let requests: any = {};
    if (router.params.id) {
      requests["train"] = () => trainsService.get(router.params.id);
    }
    return useLoadAll(requests);
  }),
);
